import styled from '@emotion/styled';
import { LoadingIndicator } from '@triumph/design-system';

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    min-height: 100vh;
    flex-direction: column;
`;

const LoadingPage = () => (
    <Container>
        <LoadingIndicator
            loadingTestId="styled-loading-indicator"
            message="Loading..."
            show={true}
        ></LoadingIndicator>
    </Container>
);

export default LoadingPage;
